<template>
  <div class="landing-page">
    <!-- 1. Hero Section -->
    <section class="hero-section"
      :style="{ backgroundImage: `url('https://qiniu-au.wifigsmalarm.com/images/banner.png')`, backgroundSize: 'cover', backgroundPosition: 'center' }">
      <div class="hero-container">
        <!-- 居中文字内容 (渐显动画) -->
        <div class="hero-content animate-fade-in">
          <h1 v-html="t('hero.title')"></h1>
          <p class="hero-description">{{ t('hero.desc1') }}</p>
          <p class="hero-description">{{ t('hero.desc2') }}</p>
          <p class="hero-description">{{ t('hero.desc3') }}</p>
        </div>
      </div>
    </section>

    <section class="section bg-light overflow-hidden app-diagram-section">
      <!-- 头部标题 -->
      <div class="section-header text-center" v-scroll-reveal>
        <h2 class="section-title">{{ t('main1.title') }}</h2>
        <p class="section-subtitle">
          {{ t('main1.subtitle') }}
        </p>
      </div>

      <!-- 核心连线交互图 -->
      <div class="app-diagram-container">

        <!-- 左侧特征卡片与连线 -->
        <div class="diagram-item left" v-for="(item, index) in appFeaturesLeft1" :key="'left-' + index"
          :style="{ top: item.top }" v-scroll-reveal.slide-right>
          <div class="item-card">{{ item.text }}</div>
          <div class="item-line"></div>
          <div class="item-dot"></div>
        </div>

        <!-- 中间手机图 (请替换为仅有手机界面的透明底 PNG 图片) -->
        <img class="center-phone" src="https://qiniu-au.wifigsmalarm.com/images/home.jpg" alt="App Home Page"
          v-scroll-reveal.zoom />

        <!-- 右侧特征卡片与连线 -->
        <div class="diagram-item right" v-for="(item, index) in appFeaturesRight1" :key="'right-' + index"
          :style="{ top: item.top }" v-scroll-reveal.slide-left>
          <div class="item-card">{{ item.text }}</div>
          <div class="item-line"></div>
          <div class="item-dot"></div>
        </div>

      </div>
    </section>

    <section class="section overflow-hidden app-diagram-section">
      <!-- 头部标题 -->
      <div class="section-header text-center" v-scroll-reveal>
        <h2 class="section-title">{{ t('main2.title') }}</h2>
        <p class="section-subtitle">
          {{ t('main2.subtitle') }}
        </p>
      </div>

      <!-- 核心连线交互图 -->
      <div class="app-diagram-container">

        <!-- 左侧特征卡片与连线 -->
        <div class="diagram-item left" v-for="(item, index) in appFeaturesLeft2" :key="'left-' + index"
          :style="{ top: item.top }" v-scroll-reveal.slide-right>
          <div class="item-card">{{ item.text }}</div>
          <div class="item-line"></div>
          <div class="item-dot"></div>
        </div>

        <!-- 中间手机图 (请替换为仅有手机界面的透明底 PNG 图片) -->
        <img class="center-phone" src="https://qiniu-au.wifigsmalarm.com/images/device.png" alt="App Home Page"
          v-scroll-reveal.zoom />

        <!-- 右侧特征卡片与连线 -->
        <div class="diagram-item right" v-for="(item, index) in appFeaturesRight2" :key="'right-' + index"
          :style="{ top: item.top }" v-scroll-reveal.slide-left>
          <div class="item-card">{{ item.text }}</div>
          <div class="item-line"></div>
          <div class="item-dot"></div>
        </div>

      </div>
    </section>

    <section class="section bg-light overflow-hidden app-diagram-section">
      <!-- 头部标题 -->
      <div class="section-header text-center" v-scroll-reveal>
        <h2 class="section-title">{{ t('main3.title') }}</h2>
        <p class="section-subtitle">
          {{ t('main3.subtitle') }}
        </p>
      </div>

      <!-- 核心连线交互图 -->
      <div class="app-diagram-container">

        <!-- 左侧特征卡片与连线 -->
        <div class="diagram-item left" v-for="(item, index) in appFeaturesLeft3" :key="'left-' + index"
          :style="{ top: item.top }" v-scroll-reveal.slide-right>
          <div class="item-card">{{ item.text }}</div>
          <div class="item-line"></div>
          <div class="item-dot"></div>
        </div>

        <!-- 中间手机图 (请替换为仅有手机界面的透明底 PNG 图片) -->
        <img class="center-phone" src="https://qiniu-au.wifigsmalarm.com/images/smart.jpg" alt="App Home Page"
          v-scroll-reveal.zoom />

        <!-- 右侧特征卡片与连线 -->
        <div class="diagram-item right" v-for="(item, index) in appFeaturesRight3" :key="'right-' + index"
          :style="{ top: item.top }" v-scroll-reveal.slide-left>
          <div class="item-card">{{ item.text }}</div>
          <div class="item-line"></div>
          <div class="item-dot"></div>
        </div>

      </div>
    </section>


    <!-- 6. Get Started -->
    <section class="section overflow-hidden">
      <h2 class="section-title text-center" v-scroll-reveal>{{ t('software.title') }}</h2>
      <div class="grid-container grid-3">
        <div class="step-card" v-for="(step, index) in steps" :key="index" v-scroll-reveal
          :style="{ transitionDelay: `${index * 100}ms`, cursor: 'pointer' }" :class="{ 'is-clickable': step.link }"
          @click="handleCardClick(step)">
          <img class="step-img" :src="getAssetIcon(step.icon)" />
          <h4>{{ step.title }}</h4>
          <p>{{ step.desc }}</p>

          <div v-if="step.qrCode" class="qr-overlay">
            <img :src="step.qrCode" alt="QR" class="qr-img" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const iconModules = import.meta.glob('../assets/icons/*.png', { eager: true });

const getAssetIcon = (name) => {
  const globPath = `../assets/icons/${name}.png`;
  if (iconModules[globPath]) {
    return iconModules[globPath].default;
  } else {
    console.warn(`Icon ${name} not found, displaying default.`);
    return;
  }
}

const vScrollReveal = {
  mounted: (el, binding) => {
    const isZoom = binding.modifiers.zoom
    el.classList.add(isZoom ? 'reveal-zoom-before-enter' : 'reveal-before-enter')

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.classList.add('reveal-enter')
          observer.unobserve(el)
        }
      })
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    })
    observer.observe(el)
  }
}

const appFeaturesLeft1 = computed(() => [
  {
    top: '8%',
    text: t('main1.desc1')
  },
  {
    top: '35%',
    text: t('main1.desc2')
  },
  {
    top: '78%',
    text: t('main1.desc3')
  }
])

// App 首页功能分解 (右侧)
const appFeaturesRight1 = computed(() => [
  {
    top: '8%',
    text: t('main2.desc4')
  },
  {
    top: '26%',
    text: t('main2.desc5')
  },
  {
    top: '56%',
    text: t('main2.desc6')
  },
  {
    top: '78%',
    text: t('main2.desc7')
  }
])

const appFeaturesLeft2 = computed(() => [
  {
    top: '43%',
    text: t('main2.desc1')
  },
  {
    top: '52%',
    text: t('main2.desc2')
  },
  {
    top: '66%',
    text: t('main2.desc3')
  },
  {
    top: '80%',
    text: t('main2.desc4')
  }
])

// App 首页功能分解 (右侧)
const appFeaturesRight2 = computed(() => [
  {
    top: '43%',
    text: t('main2.desc5')
  },
  {
    top: '52%',
    text: t('main2.desc6')
  },
  {
    top: '66%',
    text: t('main2.desc7')
  },
  {
    top: '80%',
    text: t('main2.desc8')
  }
])

const appFeaturesLeft3 = computed(() => [

  {
    top: '13%',
    text: t('main3.desc1')
  },
  {
    top: '30%',
    text: t('main3.desc2')
  }
])

// App 首页功能分解 (右侧)
const appFeaturesRight3 = computed(() => [
  {
    top: '0%',
    text: t('main3.desc3')
  },
  {
    top: '52%',
    text: t('main3.desc4')
  },

])


const steps = computed(() => [
  { icon: 'cms', title: t('software.steps.cms.title'), desc: t('software.steps.cms.desc'), link: 'https://new-cms.wifigsmalarm.com' },
  { icon: 'kooyii', title: t('software.steps.kooyii.title'), desc: t('software.steps.kooyii.desc'), qrCode: 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://vuejs.org/' },
  { icon: 'old', title: t('software.steps.elderly.title'), desc: t('software.steps.elderly.desc'), link: '/contact' },
  { icon: 'hotel', title: t('software.steps.hotel.title'), desc: t('software.steps.hotel.desc'), link: '/contact' },
  { icon: 'building', title: t('software.steps.building.title'), desc: t('software.steps.building.desc'), link: '/contact' },
  { icon: 'more', title: t('software.steps.more.title'), desc: t('software.steps.more.desc'), link: '/contact' }
])

const handleCardClick = (step) => {
  if (step.link) {
    window.open(step.link, '_blank')
  }
}
</script>

<style scoped>
/* --- 全局样式 --- */
.landing-page {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  color: #333;
  line-height: 1.6;
  overflow-x: hidden;
}

.text-center {
  text-align: center;
}

.text-left-pc {
  text-align: left;
}

.bg-light {
  background-color: #f9fafb;
}

.section {
  padding: 80px 20px;
}

.section-title {
  font-size: 2.2rem;
  margin-bottom: 50px;
  font-weight: 700;
}

.overflow-hidden {
  overflow: hidden;
}


/* =========================================
   动画核心 CSS 样式 
   ========================================= */
.reveal-before-enter {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.reveal-zoom-before-enter {
  opacity: 0;
  transform: translateY(40px) scale(0.95);
  transition: opacity 1s cubic-bezier(0.16, 1, 0.3, 1), transform 1s cubic-bezier(0.16, 1, 0.3, 1);
}

.reveal-before-enter.slide-right {
  transform: translateX(-40px);
}

.reveal-before-enter.slide-left {
  transform: translateX(40px);
}

.reveal-zoom-before-enter.slide-right {
  transform: translateX(-40px) scale(0.95);
}

.reveal-zoom-before-enter.slide-left {
  transform: translateX(40px) scale(0.95);
}

.reveal-enter {
  opacity: 1 !important;
  transform: translate(0, 0) scale(1) !important;
}

.app-diagram-section {
  padding: 80px 20px 120px 20px;
}

.section-subtitle {
  color: #666;
  font-size: 1.1rem;
  max-width: 800px;
  margin: 0 auto 60px auto;
  line-height: 1.6;
}

/* 核心图表容器 */
.app-diagram-container {
  position: relative;
  max-width: 1200px;
  /* 限制最大宽度，屏幕再大也不会无限拉伸 */
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

/* 中间手机图片 */
.center-phone {
  width: 100%;
  max-width: 320px;
  /* 设定手机固定宽度 */
  height: auto;
  position: relative;
  z-index: 5;
  filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.15));
}

/* 统一的单行元素（卡片 + 连线 + 圆点） */
.diagram-item {
  position: absolute;
  display: flex;
  align-items: center;
  /* ✨ 核心防错位计算：总宽度 50% 减去手机一半宽度再往里缩进20px，确保圆点刚好压在手机边上 */
  width: calc(50% - 140px);
  transform: translateY(-50%);
  /* 确保连线严格垂直居中于 top 的百分比 */
  z-index: 10;
}

/* 左侧项定位与排版 */
.diagram-item.left {
  left: 0;
}

.diagram-item.left .item-card {
  text-align: right;
}

/* 右侧项定位与排版 (倒序排列：圆点-线-卡片) */
.diagram-item.right {
  right: 0;
  flex-direction: row-reverse;
}

.diagram-item.right .item-card {
  text-align: left;
}

/* 边框文字卡片 */
.item-card {
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 15px 20px;
  border-radius: 12px;
  width: 280px;
  /* 卡片固定宽度 */
  font-size: 0.9rem;
  color: #444;
  line-height: 1.5;
  flex-shrink: 0;
  /* 防止卡片被线挤压变形 */
}

/* 纯 CSS 连线 */
.item-line {
  flex-grow: 1;
  /* ✨ 核心魔法：自动填满卡片和圆点之间的剩余空隙 */
  height: 1px;
  background-color: #cbd5e1;
  position: relative;
  min-width: 20px;
  /* 屏幕缩小时保持最低限度的线长 */
}

/* 指向手机的圆点 */
.item-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #0987fc;
  box-shadow: 0 0 0 4px rgba(9, 135, 252, 0.2);
  /* 淡淡的光晕效果 */
  flex-shrink: 0;
}

/* =========================================
   首屏 Hero Section 
   ========================================= */
.hero-section {
  /* 黑色高级质感展示 */
  width: 100%;
  min-height: 55vh;
  /* 撑开一定的高度 */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120px 20px 80px 20px;
  position: relative;
  z-index: 2;
}

.hero-container {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1000px;
  /* 稍微缩窄文字最大宽度，阅读体验更好 */
  width: 100%;
  margin: 0 auto;
}

.hero-content {
  color: #111111;
  text-align: center;
  /* ✨ 文字严格居中 */
  z-index: 2;
}

.hero-content h1 {
  font-size: 3.8rem;
  /* 居中后字号可以适当放大 */
  font-weight: bold;
  margin-bottom: 25px;
  line-height: 1.2;
  letter-spacing: 2px;
}

.hero-description {
  font-size: 1.2rem;
  margin: 0 auto;
  /* ✨ 描述文字也居中对齐 */
  color: rgba(0, 0, 0, 0.8);
  /* 柔和的白色，避免刺眼 */
  line-height: 1.8;
  max-width: 750px;
  letter-spacing: 0.5px;
}

/* =========================================
   首屏渐显动画 (Fade In)
   ========================================= */
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(30px);
    /* 微微上浮，增加动效质感 */
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fadeIn 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.hero-image-wrapper {
  flex: 0.9;
  display: flex;
  justify-content: flex-end;
  position: relative;
  /* ⬇️ 关键：提高图片的 z-index，确保它能盖在下面白色的 section 上 */
  z-index: 10;
}

.hero-image {
  max-width: 100%;
  height: auto;
  max-height: 650px;
  margin-top: 5vh;
  /* ⬇️ 关键：使用负的下边距，强行让图片向下突破首屏的流式布局 */
  margin-bottom: -100px;
  object-fit: contain;
  /* ⬇️ 优化：加上一层阴影，当图片叠在下方白色背景时会有很棒的立体悬浮感（类似你提供的参考图） */
  filter: drop-shadow(0 25px 40px rgba(0, 0, 0, 0.2));
}

@keyframes slideInLeft {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-slide-in-left {
  animation: slideInLeft 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.animate-slide-in-right {
  animation: slideInRight 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  animation-delay: 0.2s;
  opacity: 0;
}

/* =========================================
   Grid & Features
   ========================================= */
.grid-container {
  display: grid;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.card {
  background: white;
  padding: 40px 30px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.card-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: block;
}

.card h3 {
  margin-bottom: 15px;
  font-size: 1.3rem;
}

.card p {
  color: #666;
  font-size: 0.95rem;
}

.feature-rows {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 60px;
}

.feature-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
}

.feature-row.reverse-row {
  flex-direction: row-reverse;
}

.feature-content {
  flex: 1;
}

.feature-content h3 {
  font-size: 1.8rem;
  margin-bottom: 20px;
}

.feature-content p {
  color: #555;
  font-size: 1.1rem;
}

.feature-image {
  flex: 1;
  border-radius: 16px;
  width: 300px;
  height: 350px;
  object-fit: contain;
}

/* 关于我们页面的那张大图单独限制一下 */
.about-img {
  height: 600px;
}

/* Step Cards */
.step-card {
  background: white;
  padding: 30px 20px;
  border-radius: 16px;
  border: 1px solid #eaeaea;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
}

.step-img {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  margin: 0 auto 20px auto;
  display: block;
}

.step-card h4 {
  font-size: 1.1rem;
  margin-bottom: 10px;
}

.step-card p {
  font-size: 0.85rem;
  color: #666;
}

.qr-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(4px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
  transform: scale(0.95);
  transition: all 0.3s ease;
  z-index: 10;
}

.step-card:hover .qr-overlay {
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: auto !important;
  transform: scale(1);
}

/* =========================================
   Awesome Features
   ========================================= */
.awesome-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  gap: 30px;
}

.awesome-column.left-column,
.awesome-column.right-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.awesome-column.center-column {
  flex: 0 0 350px;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 10;
}

.phone-mockup {
  width: 100%;
  max-width: 320px;
  filter: drop-shadow(0 25px 40px rgba(0, 0, 0, 0.15));
}

.awesome-card {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  background: #ffffff;
  padding: 25px;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.04);
  text-align: left;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.awesome-card:hover {
  transform: translateY(-5px) !important;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.08);
}

.feat-icon .icon {
  width: 70px;
  height: 70px;
  flex-shrink: 0;
}

.feat-text h4 {
  font-size: 1.25rem;
  margin-bottom: 8px;
  font-weight: 700;
  color: #111;
}

.feat-text p {
  font-size: 0.95rem;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

.multi-feature-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  /* 控制上下左右的间距，40px 足够防止重叠 */
  align-items: stretch;
  /* ✨ 让同一行的卡片自动等高，不要在子元素写 height: 100% */
}

.multi-feature-card {
  background-color: #ffffff;
  border-radius: 24px;
  padding: 60px 40px 0 40px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  /* ⚠️ 核心修复：把之前的 height: 100% 删掉！Grid 默认会自动拉伸，写死 100% 会导致高度计算溢出 */
  transform: translateY(-5px);
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.08);
}


.multi-feature-text h3 {
  font-size: 2.2rem;
  font-weight: 700;
  color: #111;
  margin-bottom: 20px;
}

.multi-feature-text p {
  font-size: 1.05rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 40px;
}

.multi-feature-image {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  /* ✨ 确保图片紧贴底部容器 */
  margin-top: auto;
}

.multi-feature-image img {
  max-width: 100%;
  height: auto;
  max-height: 380px;
  /* ✨ 核心修复：给图片一个最大高度，防止原图尺寸过大撑破卡片导致下一行重叠 */
  object-fit: contain;
  object-position: bottom;
  /* 图片对齐到底部 */
  display: block;
  padding-bottom: 100px;
}

/* 控制只在电脑端强制换行的工具类 */
.pc-only {
  display: block;
}


/* =========================================
   ✨ 移动端自适应 (Mobile Responsive) ✨
   ========================================= */
@media (max-width: 1024px) {
  .hero-container {
    gap: 40px;
  }

  .awesome-content {
    gap: 15px;
  }

  .awesome-card {
    padding: 15px;
  }

  .awesome-column.center-column {
    flex: 0 0 280px;
  }
}

@media screen and (max-width: 992px) {

  /* 平板尺寸下稍微缩小卡片 */
  .item-card {
    width: 220px;
    padding: 12px 15px;
    font-size: 0.85rem;
  }
}

@media screen and (max-width: 768px) {
  .app-diagram-container {
    flex-direction: column;
    align-items: center;
  }

  .center-phone {
    margin-bottom: 40px;
    max-width: 260px;
  }

  /* 手机端取消绝对定位，回归标准文档流 */
  .diagram-item {
    position: relative;
    width: 100%;
    transform: none;
    top: auto !important;
    /* 强制覆盖 JS 绑定的 top 百分比 */
    margin-bottom: 20px;
    justify-content: center;
  }

  .diagram-item.left,
  .diagram-item.right {
    flex-direction: column;
    /* 手机端统一改为竖排 */
  }

  /* 隐藏在手机上难以对齐的连线和圆点 */
  .item-line,
  .item-dot {
    display: none;
  }

  .item-card {
    width: 100%;
    max-width: 400px;
    text-align: center !important;
    border: 1px solid #0987fc30;
    /* 手机端给边框加点主题色点缀 */
  }

  /* 1. 全局边距与文字缩小 */
  .section {
    padding: 40px 15px;
  }

  .section-title {
    font-size: 1.8rem;
    margin-bottom: 30px;
  }

  /* 2. 首屏 Banner 垂直排布 */
  .hero-section {
    padding: 40px 20px 0 20px;
    /* 手机端同样去掉底部 padding */
  }

  .hero-container {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }

  .hero-content {
    text-align: center;
  }

  .hero-content h1 {
    font-size: 2.2rem;
  }

  .hero-description {
    font-size: 1rem;
    margin: 0 auto 20px auto;
  }

  .hero-image {
    margin-top: 10px;
    max-height: 350px;
    /* ⬇️ 手机端缩小负边距，让它微微超出一部分即可 */
    margin-bottom: -40px;
  }

  /* 3. Grid 和 关于我们 布局重构 */
  .grid-3 {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .feature-row,
  .feature-row.reverse-row {
    flex-direction: column-reverse;
    /* 文字在下，图片在上 */
    text-align: center;
    gap: 20px;
  }

  .text-left-pc {
    text-align: center;
  }

  /* 解决内联 600px 导致的拉伸问题 */
  .feature-image,
  .about-img {
    height: auto;
    max-height: 280px;
    width: 100%;
  }

  /* 4. Awesome Features（卡片区） */
  .awesome-content {
    flex-direction: column;
    gap: 30px;
  }

  .awesome-column.center-column {
    order: -1;
    /* 手机端把中间的手机图排到最前面 */
    flex: auto;
    margin-bottom: 10px;
  }

  .phone-mockup {
    max-width: 200px;
    /* 手机端缩小展示机型 */
  }

  .awesome-card {
    flex-direction: column;
    /* 图标和文字上下排列 */
    align-items: center;
    text-align: center;
    padding: 20px 15px;
  }

  .feat-icon .icon {
    width: 50px;
    height: 50px;
  }

  /* 5. 动画修正，去掉左右移动改为单纯上下浮现（防止水平溢出和破坏体验） */
  .reveal-before-enter.slide-right,
  .reveal-before-enter.slide-left,
  .reveal-zoom-before-enter.slide-right,
  .reveal-zoom-before-enter.slide-left {
    transform: translateY(30px);
  }

  .multi-feature-container {
    /* ✨ 关键修改：在手机端强制变回一行一个 */
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .multi-feature-card {
    padding: 40px 20px 0 20px;
    border-radius: 20px;
  }

  .multi-feature-text h3 {
    font-size: 1.6rem;
    margin-bottom: 15px;
  }

  .multi-feature-text p {
    font-size: 1rem;
    margin-bottom: 30px;
  }

  .pc-only {
    display: none;
  }
}
</style>